import { defineMessages } from 'react-intl';

export const selectionAiActionsMessages = defineMessages({
  rewrite: {
    defaultMessage: 'Rewrite',
    id: 'I6jJ9ihLBW',
    description: 'Selection menu action that asks Heidi to rewrite the highlighted text',
  },
  makeShorter: {
    defaultMessage: 'Make shorter',
    id: '2Cmy/YiTUJ',
    description: 'Selection menu action that asks Heidi to shorten the highlighted text',
  },
  addMoreDetail: {
    defaultMessage: 'Add more detail',
    id: 'x9CWyd1tlE',
    description:
      'Selection menu action (v1) that asks Heidi to expand the highlighted text with more detail',
  },
  simplifyLanguage: {
    defaultMessage: 'Simplify language',
    id: 'Obf59Wy1Wr',
    description:
      'Selection menu rewrite option that asks Heidi to simplify the wording of the highlighted text',
  },
  checkWithGuidelines: {
    defaultMessage: 'Look up evidence',
    id: 'lCCTtydbTT',
    description:
      'Selection menu action that asks Heidi to check the highlighted text against clinical guidelines',
  },
  viewSource: {
    defaultMessage: 'View transcript',
    id: 'Om0VtfiW3c',
    description:
      'Selection menu action that asks Heidi to show the transcript passages that informed the highlighted text',
  },
  askAnything: {
    defaultMessage: 'Ask anything',
    id: '5B0BfblbNz',
    description:
      'Selection menu button that focuses the Ask Heidi chat bar with the highlighted text as context',
  },
  askHeidiToEdit: {
    defaultMessage: 'Ask Heidi to edit',
    id: 'fwjixMMYiJ',
    description:
      'v5.2 selection menu button (replaces "Ask anything") that opens the free-form AI edit prompt for the highlighted text',
  },
  aiActions: {
    defaultMessage: 'Ask Heidi',
    id: 'mOs2a9lT+c',
    description:
      'Selection menu button label that opens the dropdown of Heidi AI actions for the highlighted text',
  },
  editWithAiPlaceholder: {
    defaultMessage: 'Ask to edit',
    id: '4S/yrF4G9g',
    description:
      'Placeholder for the prompt field at the foot of the Ask Heidi menu where the user types a free-form edit instruction',
  },
  moreOptions: {
    defaultMessage: 'More options',
    id: '68Skf0Q9+U',
    description:
      'Selection menu row that opens a submenu grouping the editor actions (find & replace, create snippet, convert to section)',
  },
  findReplace: {
    defaultMessage: 'Find and replace',
    id: '0H24MbTujY',
    description:
      'More options submenu action that opens find and replace for the selection',
  },
  createSnippet: {
    defaultMessage: 'Create snippet',
    id: 'MLdEyXq3/i',
    description:
      'More options submenu action that saves the highlighted text as a snippet',
  },
  convertToSection: {
    defaultMessage: 'Convert to section',
    id: '0LMQP0PAAB',
    description:
      'More options submenu action that converts the highlighted text into a section',
  },
});
